import { Shield } from 'lucide-react';

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE = {
  sm: 'h-5',
  md: 'h-6',
  lg: 'h-8',
};

const TEXT = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-xl',
};

export function BrandLogo({ size = 'md', className = '' }: BrandLogoProps) {
  return (
    <div className={`flex items-center gap-2 font-bold text-foreground ${className}`}>
      <div className={`${SIZE[size]} aspect-square flex items-center justify-center rounded-xl bg-brand text-brand-foreground`}>
        <Shield className="w-[60%] h-[60%]" />
      </div>
      <span className={TEXT[size]}>Replya</span>
    </div>
  );
}
